( function () {
    'use strict';
    e.dw = {};
    e.dw.fixPhoneLinks = function () {
        jQuery( 'a[href^="http://tel:"]' ).attr( 'href', function () {
            return this.href.substring( 7 ).replace( '/', '' );
        } );
    };
    e.dw.buildImageURL = function ( image, height, width ) {
        var imageURL = '/admin/public/getimage.ashx?crop=0&image=' + image;
        if ( height !== 'auto' ) {
            imageURL = imageURL + '&Height=' + height;
        }
        if ( width !== 'auto' ) {
            imageURL = imageURL + '&Width=' + width;
        }
        return imageURL;
    };
    e.dw.extranet = {};
    e.dw.extranet.init = function () {
        e.dw.extranet.login.init();
        e.dw.extranet.user.init();
    };
    e.dw.extranet.login = {};
    e.dw.extranet.login.init = function () {
        e.dw.extranet.login.inpage();
        e.dw.extranet.login.modal();
    };
    // Tilf&oslash;j validering af extranet login form
    e.dw.extranet.login.inpage = function () { //handle inpage vs modal
        jQuery( '.e-content' ).find( 'form[name="ExtUserForm"]' ).find( 'input[name="Username"]' ).focus().end().validate();
        e.dw.extranet.login.remember();
    };
    e.dw.extranet.login.modal = function () {
        var jLoginModal = jQuery( '.js-e-login-modal' ),
            jLoginModalLink = jQuery( '.js-e-login-modal-link ' );
        if ( jLoginModal.length === 1 && jLoginModalLink.length > 0 ) {
            var DW_Extranet = jQuery.cookie( 'DW_Extranet' );
            if ( DW_Extranet && DW_Extranet.split( '&' )[ 0 ].split( '=' )[ 1 ] !== '' ) {
                jLoginModal.find( '.js-e-login-modal-load-content' ).load( jLoginModalLink.attr( 'href' ) + ' .js-e-login', function () {
                    jLoginModal.find( 'form[name="ExtUserForm"]' ).validate();
                    e.dw.extranet.login.remember();
                } );
            }
            else {
                jLoginModal.find( 'form[name="ExtUserForm"]' ).validate();
                e.dw.extranet.login.remember();
            }
            jLoginModal.on( 'shown', function () {
                jLoginModal.find( 'input[name="Username"]' ).focus();
            } );
            if ( jLoginModal.find( '.alert' ).length === 1 ) {
                jLoginModal.modal( 'show' );
            }
            jLoginModalLink.on( 'click', function ( event ) {
                event.preventDefault();
                jLoginModal.modal( 'show' );
            } );
            jLoginModal.find( 'a.btn' ).attr( 'href', function () {
                if ( this.href.indexOf( '?extranet_login_redirect=' ) === -1 ) {
                    return this.href + '?extranet_login_redirect=' + decodeURIComponent( jLoginModal.data( 'extranet_login_redirect' ) );
                }
                else {
                    return this.href;
                }
            } );
        }
    };
    e.dw.extranet.login.remember = function () {
        jQuery( 'form[name="ExtUserForm"] .eExtranetRemember' ).on( 'change', function () {
            jQuery( this.form ).find( '.eExtranetRememberUsername, .eExtranetRememberPassword' ).val( ( jQuery( this ).prop( 'checked' ) === true ? 'True' : '' ) );
        } ).triggerHandler( 'change' );
    };
    e.dw.extranet.user = {};
    // Tilf&oslash;j validering af extranet create/edit profile form
    e.dw.extranet.user.init = function () {
        var jUserManagementEditForm = jQuery( '.e-content form[name="UserManagementEditForm"]' );
        jUserManagementEditForm.validate( {
            rules: {
                UserManagement_Form_OldPassword: {
                    required: function () {
                        return jQuery( '#UserManagement_Form_NewPassword' ).val().length !== 0;
                    }
                },
                UserManagement_Form_NewPasswordConfirm: {
                    equalTo: '#UserManagement_Form_NewPassword'
                }
            },
            groups: {
                UserManagement_Form_Zip: 'UserManagement_Form_Zip UserManagement_Form_City'
            },
            submitHandler: function ( form ) {
                if ( form.UserManagement_Form_NewPassword.value === '' && form.UserManagement_Form_NewPasswordConfirm.value === '' ) {
                    jUserManagementEditForm.find( ':password' ).prop( 'disabled', true );
                }
                else {
                    jUserManagementEditForm.find( ':password' ).filter( function () {
                        return this.value === '';
                    } ).prop( 'disabled', true );
                }
                form.submit();
            }
        } );
        if ( jQuery( '#UserManagement_Form_OldPassword' ).length === 1 ) {
            jQuery( '#UserManagement_Form_NewPassword' ).on( 'change keyup', function () {
                jQuery( '#UserManagement_Form_OldPassword' ).valid();
            } );
        }
    };
}() );
